export const CASE_STUDIES = [
  {
    slug: "the-essex-transformation",
    title: "The Essex Transformation",
    subtitle: "Full Property Renovation",
    location: "Chigwell, Essex",
    category: "Renovations & Conversions",
    hero: {
      url: "https://images.unsplash.com/photo-1748063578185-3d68121b11ff?crop=entropy&cs=srgb&fm=jpg&q=85",
      alt: "Finished modern luxury Essex property exterior illuminated at dusk",
    },
    overview:
      "A complete property transformation — from existing structures on site through to a fully managed renovation delivered with a single point of contact. Tyrell Property Services coordinated every trade, material and schedule from initial strip-out to final finish.",
    scope: [
      "Full strip-out and structural works",
      "Coordination of all specialist trades",
      "Materials sourcing and schedule management",
      "Complete interior renovation and finishing",
      "Exterior transformation and landscaping coordination",
    ],
    outcomes: [
      "Existing structures transformed into a modern, high-end home",
      "One managed programme from demolition through to completion",
      "Weekly progress updates and transparent communication throughout",
      "Finished to a premium standard inside and out",
    ],
    gallery: [
      {
        url: "https://images.unsplash.com/photo-1659633874076-82f57ba8b486?crop=entropy&cs=srgb&fm=jpg&q=85",
        alt: "Original unrenovated structure prior to groundworks",
        label: "Before Works",
      },
      {
        url: "https://images.unsplash.com/photo-1593786267440-550458cc882a?crop=entropy&cs=srgb&fm=jpg&q=85",
        alt: "Structural blockwork and timber scaffolding mid-renovation",
        label: "Works Underway",
      },
      {
        url: "https://images.unsplash.com/photo-1751346874267-ace7c47ba9b5?crop=entropy&cs=srgb&fm=jpg&q=85",
        alt: "Completed luxury modern residential exterior with warm architectural lighting",
        label: "Finished Exterior",
      },
      {
        url: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?crop=entropy&cs=srgb&fm=jpg&q=85",
        alt: "Bespoke open-plan modern interior living space with warm ambient lighting",
        label: "Finished Interior",
      },
    ],
  },
  {
    slug: "period-residence-brentwood",
    title: "Period Residence Renovation",
    subtitle: "Victorian Property Restoration",
    location: "Brentwood, Essex",
    category: "Renovations & Conversions",
    hero: {
      url: "https://images.unsplash.com/photo-1787405148845-6e34646de7a5?crop=entropy&cs=srgb&fm=jpg&q=85",
      alt: "Victorian red-brick period residence exterior under golden hour light",
    },
    overview:
      "A sensitive renovation of a period Victorian residence — retaining original character while bringing every room up to a modern luxury standard. Specialist trades were sequenced carefully to protect heritage features throughout the programme.",
    scope: [
      "Heritage-sensitive structural repairs",
      "Full kitchen and bathroom renovation",
      "Restoration of period features and mouldings",
      "Rewiring, heating and insulation upgrades",
      "Bespoke joinery and premium finishing",
    ],
    outcomes: [
      "Original period character preserved and restored",
      "Kitchen and bathrooms finished to a luxury standard",
      "Modern comfort upgrades discreetly integrated",
      "Delivered by trusted specialist trades under one point of contact",
    ],
    gallery: [
      {
        url: "https://images.unsplash.com/photo-1648881806148-e5c51179c826?crop=entropy&cs=srgb&fm=jpg&q=85",
        alt: "Restored Victorian period brickwork and sash window detailing",
        label: "Period Facade",
      },
      {
        url: "https://images.unsplash.com/photo-1556911220-e15b29be8c8f?crop=entropy&cs=srgb&fm=jpg&q=85",
        alt: "Custom renovated kitchen with natural stone island and premium cabinetry",
        label: "Renovated Kitchen",
      },
      {
        url: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?crop=entropy&cs=srgb&fm=jpg&q=85",
        alt: "High-end marble bathroom suite with freestanding bath",
        label: "Renovated Bathroom",
      },
      {
        url: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?crop=entropy&cs=srgb&fm=jpg&q=85",
        alt: "Restored period living room with high ceilings and warm lighting",
        label: "Living Space",
      },
    ],
  },
  {
    slug: "grand-lounge-extension-epping",
    title: "Grand Lounge Extension",
    subtitle: "Contemporary Rear Extension",
    location: "Epping, Essex",
    category: "Extensions & Refurbishments",
    hero: {
      url: "https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&q=85",
      alt: "Modern structural glass rear house extension illuminated at dusk",
    },
    overview:
      "A contemporary rear extension designed around light and open-plan living. Tyrell Property Services managed the project from groundworks and structural steel through architectural glazing to a finished space that opens directly onto the garden.",
    scope: [
      "Groundworks and structural steel frame",
      "Architectural glazing and roof skylight",
      "Open-plan kitchen-diner fit-out",
      "Garden-facing landscaping and patio coordination",
      "Full project scheduling and quality control",
    ],
    outcomes: [
      "Dark rear rooms transformed into a light-filled open-plan space",
      "Seamless connection between interior and garden",
      "Structural and glazing works coordinated without disruption to the household",
      "A finished space designed around how the family actually lives",
    ],
    gallery: [
      {
        url: "https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&q=85",
        alt: "Slimline glass doors and structural overhang on garden patio",
        label: "Extension Exterior",
      },
      {
        url: "https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?crop=entropy&cs=srgb&fm=jpg&q=85",
        alt: "Sunlit open-plan kitchen and dining area opening to the patio",
        label: "Open-Plan Interior",
      },
      {
        url: "https://images.unsplash.com/photo-1600585154526-990dced4db0d?crop=entropy&cs=srgb&fm=jpg&q=85",
        alt: "Structural roof skylight flooding the interior with daylight",
        label: "Skylight Detail",
      },
      {
        url: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?crop=entropy&cs=srgb&fm=jpg&q=85",
        alt: "Precision steelwork during the extension build",
        label: "Structural Works",
      },
    ],
  },
];
